<template>

  <ValidationObserver v-slot="{ invalid }">

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <ValidationProvider v-slot="{ errors }"
                            :name="$t('profile.old-password')" rules="required">
          <vs-input v-model="form.oldPassword" :label="$t('profile.old-password') + ' *'"
                    class="w-full"
                    type="password"/>
          <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <ValidationProvider v-slot="{ errors }" :name="$t('profile.new-password')"
                            rules="required|password:@confirm" vid="newpassword">
          <vs-input v-model="form.newPassword" :label="$t('profile.new-password') + ' *'"
                    class="w-full"
                    type="password"/>
          <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

      <div class="vx-col sm:w-1/2 w-full mb-2">
        <ValidationProvider v-slot="{ errors }" :name="$t('profile.retype-new-password')"
                            rules="required|password:@newpassword" vid="confirm">
          <vs-input v-model="form.retypeNewPassword" :label="$t('profile.retype-new-password') + ' *'"
                    class="w-full"
                    type="password"/>
          <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>

    </div>
    <!----------------------------------------- Actions Button ---------------------------------------------------->
    <div class="vx-row">
      <div class="vx-col w-full mt-3">
        <vs-button :disabled="userProcessing || invalid " class="ml-2" color="primary"
                   @click.prevent="handlerSaveClick">
          {{ $t('general.save') }}
        </vs-button>
        <vs-button class="ml-2" color="dark" type="border" variant="outline"
                   @click.prevent="handlerResetForm">
          {{ $t('general.cancel') }}
        </vs-button>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import store from '@/store';
import {createNamespacedHelpers} from "vuex";
import User from '@/store/modules/user';
import {createHelpers} from "vuex-map-fields";
import {showStateNotification, showLocalNotification, notificationType} from "@/utils/notification";
import {extend} from 'vee-validate';

extend('password', {
  params: ['target'],
  validate(value, {target}) {
    if (target) {
      return value === target;
    }
    return true
  },
  message: 'Password confirmation does not match'
});

if (!store.state.User) store.state.registerModule(`User`, User);

const {
  mapFields: mapUserFields,
} = createHelpers({
  getterType: `User/getField`,
  mutationType: `User/updateField`,
});
const {
  mapActions: mapUserActions,
} = createNamespacedHelpers(`User`);


export default {
  components: {},
  data() {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        retypeNewPassword: '',
      }
    }
  },
  computed: {
    ...mapUserFields({
      userProcessing: 'processing',
      userSuccess: 'success',
      userError: 'error'
    }),
  },
  watch: {
    userSuccess(data) {
      showStateNotification(this.$vs, data);
    },
    userError(data) {
      showStateNotification(this.$vs, data);
    },
  },
  methods: {
    ...mapUserActions({
      resetPasswordCurrentUser: 'resetPasswordCurrentUser',
    }),
    async handlerSaveClick() {
      const payload = {
        oldPassword: this.form.oldPassword,
        newPassword: this.form.newPassword,
      };
      const result = await this.resetPasswordCurrentUser(payload);
      if (!result.error) {
        showLocalNotification(
          this.$vs,
          this.$t('general.success'),
          this.$t('profile.reset-password-success'),
          notificationType.SUCCESS
        );
        this.handlerResetForm();
      } else {
        showLocalNotification(
          this.$vs,
          this.$t('general.error'),
          result.message,
          notificationType.ERROR
        );
      }
    },
    handlerResetForm() {
      this.form = {
        oldPassword: '',
        newPassword: '',
        retypeNewPassword: '',
      }
    },
  },
}
</script>

<style scoped>

</style>
